import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useRecoilValue } from 'recoil';
import {
    filesProcessedState,
    filesToProcessState,
} from '~/state/atoms/dicomProcessorAtoms';

export default function FilesProcessed() {
    const filesToProcess = useRecoilValue(filesToProcessState);
    const filesProcessed = useRecoilValue(filesProcessedState);

    return (
        filesToProcess && (
            <Box
                data-testid="filesProcessing"
                position="absolute"
                overflow="hidden"
                top={0}
                left={0}
                zIndex={4000}
                width="100vw"
                height="100vh"
            >
                <Backdrop open={true} style={{ zIndex: 1300 }}>
                    <Box
                        p={2}
                        width={300}
                        borderRadius={1}
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        bgcolor={(theme) => theme.palette.background.paper}
                    >
                        <CircularProgress size={24} />
                        <Typography mt={2} variant="h6">
                            <FormattedMessage id="processingFiles" />
                        </Typography>
                        <Typography mt={2}>
                            {filesProcessed} / {filesToProcess}
                        </Typography>
                    </Box>
                </Backdrop>
            </Box>
        )
    );
}
